// src/layouts/show-list/show-list.tsx
import Divider from "@a24/ui/Divider";
import Icon from "@a24/ui/Icon";
import Label from "@a24/ui/Label";
import Link from "@a24/ui/Link";
import Title from "@a24/ui/Title";
import { format } from "date-fns";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var ShowList = ({
  className = "",
  day,
  id,
  items,
  labels = {
    bookNow: "Book now",
    flagLowAvailability: "Few seats left",
    flagSoldOut: "Sold out"
  },
  title
}) => {
  if (!title || !items) {
    return;
  }
  if (!items[0]?.parentShow?.page) return;
  const layoutName = "ShowList";
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: `${className} bg-heritage-white-full rounded-sm border-1 border-heritage-off-white-80 grid grid-cols-12 gap-x-3 w-full pt-6 pb-6 pl-[1.25rem] pr-[1.25rem] md:pt-4 md:pb-4 mb-2`,
      "data-layout": layoutName,
      id,
      children: [
        /* @__PURE__ */ jsxs("div", { className: "col-span-12 md:col-span-2 flex flex-col md:items-center justify-center mb-4 md:mb-4", children: [
          /* @__PURE__ */ jsx(Title, { level: "h2", text: title, className: "heading-md" }),
          /* @__PURE__ */ jsx("p", { className: "body-xs", children: day })
        ] }),
        items.map((item, index) => {
          if (!item.parentShow?.page) return;
          const isDisabled = Date.now() > Date.parse(item.endDate);
          const isSoldOut = item.availabilityQty === "S";
          const isLowAvailability = item.availabilityQty === "L";
          return /* @__PURE__ */ jsxs(
            "div",
            {
              className: "relative col-span-12 md:col-start-3 md:col-span-10 md:grid grid-cols-10 md:gap-x-3 md:min-h-[9.875rem] pt-6 pb-6 md:pr-14",
              children: [
                /* @__PURE__ */ jsxs("div", { className: "md:col-start-1 md:col-span-7 flex flex-col justify-center items-start", children: [
                  /* @__PURE__ */ jsx(
                    Title,
                    {
                      level: "h3",
                      text: /* @__PURE__ */ jsx(
                        Link,
                        {
                          className: "title-md text-heritage-red-full mb-2 md:w-[80%] lg:w-[100%]",
                          href: item.parentShow?.page?.path,
                          tracking: {
                            component: "Show List",
                            label: item.parentShow?.name
                          },
                          children: item.parentShow?.name
                        }
                      ),
                      className: `title-md text-heritage-red-full mb-2 md:w-[80%] lg:w-[100%] ${isDisabled || isSoldOut ? "opacity-[0.32]" : ""}`
                    }
                  ),
                  /* @__PURE__ */ jsxs("div", { className: "flex shrink-1 items-center body-xs mb-4 md:mb-0", children: [
                    /* @__PURE__ */ jsx(
                      "span",
                      {
                        className: `${isDisabled || isSoldOut ? "opacity-[0.32]" : ""}`,
                        children: format(item.startDate || "", "h:mm aaa")
                      }
                    ),
                    /* @__PURE__ */ jsx("span", { className: "ml-1 mr-1", children: "\xB7" }),
                    /* @__PURE__ */ jsx("span", { children: item.category }),
                    !isDisabled && (isSoldOut || isLowAvailability) && /* @__PURE__ */ jsxs(Fragment, { children: [
                      /* @__PURE__ */ jsx("span", { className: "ml-1 mr-1", children: "\xB7" }),
                      isSoldOut && /* @__PURE__ */ jsx(
                        Label,
                        {
                          text: labels.flagSoldOut,
                          className: "label-notification-faded"
                        }
                      ),
                      isLowAvailability && /* @__PURE__ */ jsx(
                        Label,
                        {
                          text: labels.flagLowAvailability,
                          className: "label-notification-default"
                        }
                      )
                    ] })
                  ] })
                ] }),
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: `md:col-start-8 md:col-span-3 md:flex md:items-center md:justify-end ${isDisabled || isSoldOut ? "opacity-[0.32] pointer-events-none" : ""}`,
                    children: /* @__PURE__ */ jsxs(
                      Link,
                      {
                        className: `${isDisabled || isSoldOut ? "button-secondary" : "button-primary"} group flex items-center justify-center w-full md:w-auto`,
                        href: `/order/${item.id}/seat-map`,
                        tracking: {
                          component: "Show List",
                          label: labels?.bookNow
                        },
                        children: [
                          labels.bookNow,
                          /* @__PURE__ */ jsx(
                            Icon,
                            {
                              name: "arrow-short-right",
                              className: "h-[0.7em] pt-[0.1em] group-hover:translate-x-1 transition-translate",
                              SVGClassName: "w-auto h-full"
                            }
                          )
                        ]
                      }
                    )
                  }
                ),
                index !== items.length - 1 && /* @__PURE__ */ jsx(Divider, { className: "w-full text-heritage-off-white-80 absolute bottom-0 md:w-[calc(100%-3.5rem)]" })
              ]
            },
            item.id
          );
        })
      ]
    }
  );
};
var show_list_default = ShowList;

export {
  show_list_default
};
